var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6382 15.7591C15.1811 12.7132 17.5 9.92062 17.5 6.51995C17.5 2.91908 14.5899 0 11 0C7.41015 0 4.5 2.91908 4.5 6.51995C4.5 9.92062 6.81893 12.7132 10.3618 15.7591C10.7287 16.0746 11.2713 16.0746 11.6382 15.7591ZM11 9C12.3807 9 13.5 7.88071 13.5 6.5C13.5 5.11929 12.3807 4 11 4C9.61929 4 8.5 5.11929 8.5 6.5C8.5 7.88071 9.61929 9 11 9Z",
    fill: "#4747EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2778 16C18.8237 16.4897 20.5 17.3237 20.5 18.2702C20.5 19.7778 16.2467 21 11 21C5.75329 21 1.5 19.7778 1.5 18.2702C1.5 17.3237 3.17625 16.4897 5.72222 16",
    stroke: "#4747EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnMap);
export default __webpack_public_path__ + "static/media/on_map.067f15d5bcf355a05d8cbfddd900b3ee.svg";
export { ForwardRef as ReactComponent };